/**
 * App Component
 *
 * Root component that renders the application router.
 */

import { AppRouter } from "./router";
import "./App.css";

function App() {
  return <AppRouter />;
}

export default App;
